module.exports = __webpack_public_path__ + "img/illustrator-forgot-password.540199fb.svg";